<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'drivers.driver' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<div fxLayout="row" fxLayoutAlign="center">
  @if (isActionPending | async) {
    <mat-spinner></mat-spinner>
  }
</div>

@if (!(isActionPending | async) && driver$ | async; as driver) {
  <div>
    <mat-dialog-content>
      <form [formGroup]="driverForm" appReadOnlyWithoutPermission="WRITE_DRIVERS">
        <mat-form-field>
          <mat-label>{{ 'user.firstName' | translate }}</mat-label>
          <input matInput type="text" formControlName="firstName">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.lastName' | translate }}</mat-label>
          <input matInput type="text" formControlName="lastName">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'user.abbreviation' | translate }}</mat-label>
          <input matInput type="text" formControlName="abbreviation" maxlength="4">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'vehicles.licenseClass' | translate }}</mat-label>
          <mat-select placeholder="{{ 'vehicles.licenseClass'  | translate }}" formControlName="licenseClass">
            @for (licenceClass of licenseClasses$ | async; track licenceClass) {
              <mat-option [value]="licenceClass.id">
                {{ licenceClass.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'departments.department' | translate }}</mat-label>
          <mat-select placeholder="{{ 'departments.department' | translate }}" formControlName="department">
            @for (department of departments$ | async; track department['@id']) {
              <mat-option [value]="department['@id']">
                <span class="department-color" [style.background-color]="department.color"></span>
                {{ department.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        mat-raised-button
        *ngxPermissionsOnly="['WRITE_DRIVERS']"
        color="accent"
        [disabled]="driverForm.invalid"
        disabledInteractive
        [matTooltip]="persistHint"
        (click)="persistDriver(driver)"
      >
        <mat-icon>check</mat-icon>
        {{ 'drivers.actions.persist' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
